module.exports = __webpack_public_path__ + "static/media/nft-collection-1.b80d44fd.jpg";